import { css, CSSObject } from '@emotion/react'
import { fonts, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const container = css({
  width: 552,
  minHeight: 500,
  fontFamily: fonts.sansSerif,
  backgroundColor: 'white',
  border: `1px solid ${colors.n6.base}`,
  borderRadius: '8px',
})

export const header = css({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '12px 16px',
  gap: '8px',
})

export const avatar: CSSObject = {
  borderRadius: '50%',
  flexShrink: 0,
}

export const headerInfo = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
})

export const accountNameStyle: CSSObject = {
  fontWeight: fontWeights.bold,
  color: 'rgba(0, 0, 0, 0.9)',
  lineHeight: 1.3,
}

export const headerMeta = css({
  fontSize: 12,
  color: 'rgba(0, 0, 0, 0.6)',
  lineHeight: 1.4,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const contentWrapper = css({
  padding: '0 16px 12px',
  position: 'relative',
})

export const contentTextInputStyle: CSSObject = {
  fontFamily: fonts.sansSerif,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.9)',
  lineHeight: 1.4,
  padding: 0,
  minHeight: 20,
  backgroundColor: 'transparent',

  '.tiptap': {
    padding: 2,
  },

  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },

  '&[data-readonly="true"]:hover': {
    backgroundColor: 'transparent',
  },
}

export const actions = css({
  display: 'flex',
  justifyContent: 'space-around',
  padding: '4px 8px',
  borderTop: `1px solid ${colors.n6.base}`,
})

export const actionButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: 12,
  fontWeight: fontWeights.bold,
  color: 'rgba(0, 0, 0, 0.6)',
  background: 'none',
  border: 'none',
  cursor: 'default',
  padding: '12px 8px',
  borderRadius: '4px',
  flex: 1,
  justifyContent: 'center',
  '.lapidary-icon': {
    color: 'rgba(0, 0, 0, 0.6)',
  },
})

export const carouselWidth = 552
